import { createServerFn } from '@tanstack/react-start'
import { requireSupabaseAuth } from '@/integrations/supabase/auth-middleware'

/**
 * Stuurt eenmalig een welkomstmail naar een nieuwe gebruiker.
 * Idempotent via profiles.welcome_email_sent_at — kan veilig bij elke
 * SIGNED_IN aangeroepen worden.
 */
export const sendWelcomeIfNew = createServerFn({ method: 'POST' })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    const { supabase, userId, claims } = context
    const email = (claims as any)?.email as string | undefined
    if (!email) return { ok: false, reason: 'no_email' as const }

    const { data: profile } = await supabase
      .from('profiles')
      .select('id, full_name, customer_type, welcome_email_sent_at')
      .eq('id', userId)
      .maybeSingle()
    if (!profile) return { ok: false, reason: 'no_profile' as const }
    if (profile.welcome_email_sent_at) return { ok: true, skipped: true as const }

    const { supabaseAdmin } = await import('@/integrations/supabase/client.server')

    // Claim slot eerst (race-safe)
    const { data: claimed } = await supabaseAdmin
      .from('profiles')
      .update({ welcome_email_sent_at: new Date().toISOString() })
      .eq('id', userId)
      .is('welcome_email_sent_at', null)
      .select('id')
      .maybeSingle()
    if (!claimed) return { ok: true, skipped: true as const }

    const { enqueueTransactionalEmailInternal } = await import(
      '@/lib/email/send-internal.server'
    )
    const result = await enqueueTransactionalEmailInternal({
      templateName: 'welcome',
      recipientEmail: email,
      idempotencyKey: `welcome-${userId}`,
      templateData: {
        customerName: profile.full_name ?? undefined,
        customerType: profile.customer_type ?? 'consumer',
        accountUrl: 'https://elvion-group.nl/account',
      },
    })
    return result
  })
